import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAxLCeNN6QWtSzrJgwvlt-tZWDKFEjBhrc",
  authDomain: "rob-web-fcd5f.firebaseapp.com",
  projectId: "rob-web-fcd5f",
  measurementId: "G-6RLM52T0BS"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);